export default __webpack_public_path__ + "static/media/c-logo-black.467b4cdc.png";